import React, { Component } from 'react';

class CacesBanner extends Component {

  render() {

    return (
      <div className="banner case layui-container">
        <div className="title">
          <p>関連会社</p>
          <p className="en">Associated company</p>
        </div>
      </div>
    )
  }
}

export default CacesBanner
